import { render } from "./SegmentMultiDropdown.vue?vue&type=template&id=70fa679b&scoped=true"
import script from "./SegmentMultiDropdown.vue?vue&type=script&lang=ts"
export * from "./SegmentMultiDropdown.vue?vue&type=script&lang=ts"

import "./SegmentMultiDropdown.vue?vue&type=style&index=0&id=70fa679b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70fa679b"

export default script